/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */

import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useTranslation } from "next-i18next";
import classes from '@/app/components/common/FullPageLoader/styles.module.scss';
import stylesConfig from '/styles/configs/index.module.scss';

export const FullPageLoader = (props: {
    message?:string,
    height?:string,
    variant?:string,
    additionalContent?:React.ReactNode,
}) => {
    const { t } = useTranslation();
    const message = props.message === undefined ? 'Fetching Data...' : props.message;

    if(props.variant && props.variant === 'list-item' && props.height) {
        return <li style={{
            display: 'flex',
            justifyContent: 'center',
            height: props.height }}
        >
            <span style={{ alignSelf: 'center', textAlign: 'center' }}>
                <CircularProgress aria-label={t('Loading')} />
                <p className={classes.message}>{ t(message) }</p>
                {props.additionalContent && props.additionalContent}
            </span>
        </li>
    }

    if(props.variant === 'fixed') {
        return (
            <Box sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 100000,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                background: stylesConfig.mainThemeBaseBackground,
                height: props.height ?? '100vh'
            }}>
                <Box sx={{ alignSelf: 'center', textAlign: 'center' }}>
                    <CircularProgress aria-label={t('Loading')} />
                    <p className={classes.message}>{ t(message) }</p>
                    {props.additionalContent && props.additionalContent}
                </Box>
            </Box>
        )
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', height: props.height ?? '100vh' }}>
            <Box sx={{ alignSelf: 'center', textAlign: 'center' }}>
                <CircularProgress aria-label={t('Loading')} />
                <p className={classes.message}>{ t(message) }</p>
                {props.additionalContent && props.additionalContent}
            </Box>
        </Box>
    )
}

export default FullPageLoader;